      (function() {
        var fallbackBanner = document.getElementById('bq-cookie-consent');
        var earliestFallbackDisplay = Date.now() + 10000;
        var fallbackCheckTimer;
        var nativePrivacyAvailable = false;

        if (!fallbackBanner) {
          return;
        }

        function hasSavedConsent() {
          try {
            return window.localStorage.getItem('gtag.consent.option') !== null;
          } catch (error) {
            return false;
          }
        }

        function elementIsVisible(element) {
          if (!element) {
            return false;
          }

          var styles = window.getComputedStyle(element);
          return styles.display !== 'none' && styles.visibility !== 'hidden' && styles.opacity !== '0';
        }

        function nativeBannerIsVisible() {
          var nativeBannerSelectors = [
            '#shopify-pc__banner',
            '#shopify-pc__prefs__dialog',
            '[id^="shopify-pc__"]',
            '[data-shopify-privacy-banner]',
            'shopify-privacy-banner'
          ];

          for (var index = 0; index < nativeBannerSelectors.length; index += 1) {
            var nativeBanner = document.querySelector(nativeBannerSelectors[index]);

            if (elementIsVisible(nativeBanner)) {
              return true;
            }
          }

          return false;
        }

        function customerPrivacyIsAvailable() {
          var privacy = window.Shopify && window.Shopify.customerPrivacy;

          return !!privacy && (
            typeof privacy.shouldShowBanner === 'function' ||
            typeof privacy.setTrackingConsent === 'function' ||
            typeof privacy.getTrackingConsent === 'function' ||
            typeof privacy.currentVisitorConsent === 'function'
          );
        }

        function customerHasChosen() {
          var privacy = window.Shopify && window.Shopify.customerPrivacy;

          if (!privacy) {
            return false;
          }

          if (typeof privacy.getTrackingConsent === 'function') {
            var trackingConsent = privacy.getTrackingConsent();
            if (trackingConsent && trackingConsent !== 'no_interaction') {
              return true;
            }
          }

          if (typeof privacy.currentVisitorConsent === 'function') {
            var visitorConsent = privacy.currentVisitorConsent();

            if (visitorConsent) {
              return Object.keys(visitorConsent).some(function(key) {
                var value = visitorConsent[key];
                return value !== '' && value !== null && value !== undefined;
              });
            }
          }

          return false;
        }

        function nativePrivacyShouldOwnBanner() {
          return nativePrivacyAvailable || customerPrivacyIsAvailable();
        }

        function hideFallbackBanner() {
          fallbackBanner.hidden = true;
        }

        function showFallbackBannerIfNeeded() {
          if (hasSavedConsent() || customerHasChosen() || nativeBannerIsVisible() || nativePrivacyShouldOwnBanner()) {
            hideFallbackBanner();
            return;
          }

          fallbackBanner.hidden = false;
        }

        function scheduleFallbackCheck() {
          window.clearTimeout(fallbackCheckTimer);
          fallbackCheckTimer = window.setTimeout(showFallbackBannerIfNeeded, Math.max(0, earliestFallbackDisplay - Date.now()));
        }

        function useNativePrivacyBanner() {
          nativePrivacyAvailable = true;
          window.clearTimeout(fallbackCheckTimer);
          hideFallbackBanner();
        }

        function updateShopifyConsent(granted) {
          function setConsent() {
            var privacy = window.Shopify && window.Shopify.customerPrivacy;

            if (privacy && typeof privacy.setTrackingConsent === 'function') {
              privacy.setTrackingConsent(granted, function() {});
            }
          }

          if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
            window.Shopify.loadFeatures([{
              name: 'consent-tracking-api',
              version: '0.1',
              onLoad: function(error) {
                if (!error) {
                  setConsent();
                }
              }
            }]);
          } else {
            setConsent();
          }
        }

        function saveGoogleConsent(granted) {
          if (window.BleeqUpCookieConsent && typeof window.BleeqUpCookieConsent.setConsent === 'function') {
            window.BleeqUpCookieConsent.setConsent(granted, 'theme-fallback-banner');
            return;
          }

          var option = {
            analytics_storage: granted ? 'granted' : 'denied',
            ad_storage: granted ? 'granted' : 'denied',
            ad_user_data: granted ? 'granted' : 'denied',
            ad_personalization: granted ? 'granted' : 'denied',
            functionality_storage: granted ? 'granted' : 'denied',
            personalization_storage: granted ? 'granted' : 'denied',
            security_storage: 'granted'
          };

          if (typeof window.gtag === 'function') {
            window.gtag('consent', 'update', option);
          }

          try {
            window.localStorage.setItem('gtag.consent.option', JSON.stringify(option));
          } catch (error) {
            // Consent still applies for the current page when storage is unavailable.
          }
        }

        fallbackBanner.addEventListener('click', function(event) {
          var button = event.target.closest('[data-bq-cookie-consent]');

          if (!button) {
            return;
          }

          var granted = button.getAttribute('data-bq-cookie-consent') === 'accept';
          saveGoogleConsent(granted);
          updateShopifyConsent(granted);
          hideFallbackBanner();
        });

        var nativeBannerObserver = new MutationObserver(function() {
          if (nativeBannerIsVisible() || customerPrivacyIsAvailable()) {
            useNativePrivacyBanner();
            nativeBannerObserver.disconnect();
          }
        });

        nativeBannerObserver.observe(document.documentElement, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden']
        });

        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{
            name: 'consent-tracking-api',
            version: '0.1',
            onLoad: function(error) {
              if (!error && customerPrivacyIsAvailable()) {
                useNativePrivacyBanner();
                return;
              }

              scheduleFallbackCheck();
            }
          }]);
        } else if (customerPrivacyIsAvailable()) {
          useNativePrivacyBanner();
        } else {
          scheduleFallbackCheck();
        }

        window.setTimeout(function() {
          nativeBannerObserver.disconnect();
        }, 12000);
      })();
